<template>
  <LinkCard
    :icon="['fal', 'browser']"
    :image="thumbnail"
    :title="$path('name', value)"
    :is-list="isList"
    :badges="badges"
    theme="light"
    :to="$attrs.to || { name: 'page-dashboard', params: { id: value.id }, query: $route.query }"
    class="page-link-card"
  >
    <template #title>
      <div class="page-link-card__title">
        <span>{{ $path('name', value) }}</span>

        <img
          v-if="defaultLang !== value.metadata.language"
          :alt="i18n['i18n-lang'][value.metadata.language]"
          :src="`/images/flags/${value.metadata.language}.svg`"
          width="15"
        />
      </div>
    </template>
    <template #subtitle>
      <StatusIndicator v-bind="status" />
    </template>
  </LinkCard>
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'
import { thumbhashToBase64 } from '@/utils/thumbhash'
import { Languages } from '@/components/User/Language'

export default {
  props: {
    value: Object,
    theme: {
      type: String,
      default: 'default',
    },
    defaultLang: {
      type: String,
      default: 'nb',
    },
  },
  data() {
    return {
      i18n: {
        'i18n-lang': Languages,
      },
    }
  },
  computed: {
    isList() {
      return this.theme === 'list'
    },
    thumbnail() {
      let logo = this.$path('media.logo', this.value)
      if (!logo) return
      return { src: logo.url, size: 'contain', preview: thumbhashToBase64(logo) }
    },
    status() {
      if (this.value.isArchived) return { label: this.$t('archived'), status: 'warning' }
      if (this.value.isPublished) return { label: this.$t('published'), status: 'success' }
      return { label: this.$t('unpublished'), status: 'error' }
    },
    badges() {
      if (!this.value.demo) return []
      return [{ value: this.$t('demo'), theme: 'warning' }]
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>

<style lang="scss">
.page-link-card {
  .image {
    padding: 1.5rem;
  }
  &__title {
    display: flex;
    gap: 0.5rem;
    font-weight: 700;
  }
}
</style>
